import { HttpStatusCode } from "axios";
import { _post } from "../../../api/apiClient";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_STATUS } from "../sliceUtil";
import store from "../../../app/store";

const initialSignUpState = {};

const _selectedIdrssd = () => {
  const state = store.getState();
  return (
    state?.orgReducer?.selectedFI?.idrssd ??
    state?.authReducer?.userData?.idrssd
  );
};

export const createSupportData = createAsyncThunk(
  "/faq/createSupportData",
  async ({ userBody, disableLoader }, thunkAPI) => {
    try {
      const config = {
        successMessage: "Support form sent successfully.",
        errorMessage: "Failed to send Support form.",
        isShowToast: true,
      };

      const response = await _post(`${_selectedIdrssd()}/support`, userBody);
      if (response?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, {
          ...config,
          disableToast: true,
        });
      }
      return response;
    } catch (error) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error?.error);
    }
  },
);

export const faqSlice = createSlice({
  name: "createSupportData",
  initialState: initialSignUpState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(createSupportData.pending, () => ({
        isLoading: API_STATUS.STATUS_LOADING,
      }))
      .addCase(createSupportData.fulfilled, (_state, action) => {
        return {
          isLoading: API_STATUS.STATUS_SUCCESS,
          createSupportData: action.payload,
        };
      })
      .addCase(createSupportData.rejected, (_state, action) => {
        return {
          isLoading: API_STATUS.STATUS_FAILURE,
          message: action.error.message || "Error while creating user",
          createSupportData: [],
        };
      });
  },
});

export const {} = faqSlice.actions;
